// SEO data for repair landing pages
export const SERVICE_AREAS = [
  "Susquehanna, PA",
  "Lanesboro, PA",
  "Hallstead, PA",
  "Great Bend, PA",
  "Nicholson, PA",
  "Hop Bottom, PA",
  "Kirkwood, NY",
  "Conklin, NY",
];

export const SERVICE_PAGES = {
  ps5: {
    slug: "ps5",
    device: "PlayStation 5",
    short: "PS5",
    title: "PS5 Repair in Susquehanna, PA · Cleaning, Drives, Controllers",
    metaDescription:
      "Fast, honest PS5 repair in Susquehanna PA. Full cleaning $30, controller fixes $30, drive & SSD work. Drop-off or mail-in. Serving Lanesboro, Hallstead, Great Bend, and the Binghamton NY area.",
    h1: "PlayStation 5 Repair · Susquehanna, PA",
    intro:
      "Whether your PS5 runs loud and hot, won't read discs, or has a dead controller — I diagnose every system before any work begins. Drop it off in Susquehanna or mail it in from anywhere in PA or NY.",
    commonIssues: [
      { title: "General cleaning", desc: "Years of dust kill airflow. Full deep clean of fans, heatsink, and thermal paste reapplication.", price: "$30" },
      { title: "Controller stick drift", desc: "DualSense joystick replacement. Most controllers turned around same day.", price: "$30" },
      { title: "Disc drive repair / replacement", desc: "Won't read discs, grinding noise, or won't eject. Drive cleaning, sensor swap, or full mechanism replacement depending on fault.", price: "Quote" },
      { title: "Hard drive / SSD replacement", desc: "Internal drive failure or NVMe expansion slot upgrade for more storage.", price: "Quote" },
      { title: "Power supply (case by case)", desc: "Some PS5 power supply failures are fixable with a replacement PSU. I'll diagnose and tell you straight.", price: "Quote" },
      { title: "HDMI port repair — not currently offered", desc: "I'm actively skilling up on HDMI reflow work but not accepting HDMI jobs right now. I'll happily refer you to a specialist in the meantime.", price: "—" },
    ],
    faqs: [
      {
        q: "How long does a PS5 repair take?",
        a: "Most jobs are done within 2–5 days, depending on whether parts need to be ordered. You'll get an email update when status changes.",
      },
      {
        q: "Do you repair HDMI ports on the PS5?",
        a: "Not right now. HDMI port reflow is a specialist job and I'm actively training on it — but not accepting HDMI repairs at the moment. I'll refer you to someone I trust if that's what you need. Everything else on this list is fair game.",
      },
      {
        q: "Can I mail my PS5 in for repair?",
        a: "Yes — pack it well and ship to 67 Grand St, Susquehanna PA 18847. Use the booking form to get a ticket number first so I know it's coming.",
      },
      {
        q: "Will I lose my saved games?",
        a: "No. Repairs don't touch your storage. If a drive is failing I'll always check with you before doing anything that could affect data.",
      },
    ],
    keywords: ["ps5 repair", "ps5 cleaning", "ps5 controller repair", "ps5 disc drive", "console repair Susquehanna PA"],
  },

  xbox: {
    slug: "xbox",
    device: "Xbox Series X/S & Xbox One",
    short: "Xbox",
    title: "Xbox Series X/S & Xbox One Repair · Susquehanna, PA",
    metaDescription:
      "Local Xbox repair near Binghamton. Fan cleaning, disc drive fixes, controller repair, drive & SSD work. Drop-off or mail-in. Susquehanna, Hallstead, Great Bend, Kirkwood NY, Conklin NY.",
    h1: "Xbox Repair · Series X/S, One, 360",
    intro:
      "From the original Xbox One to the Series X, I repair the issues that actually break — dead fans, disc drives that grind, dying storage, and controllers with stuck sticks. Honest pricing, no upsells.",
    commonIssues: [
      { title: "General cleaning", desc: "Deep clean and thermal paste. Brings noise and temps back to normal.", price: "$30" },
      { title: "Controller stick drift", desc: "Hall-effect or standard stick replacement. Triggers, bumpers, and sticky button fixes.", price: "$30" },
      { title: "Disc drive repair / replacement", desc: "Cleaning, lens calibration, or full drive swap depending on failure mode.", price: "Quote" },
      { title: "Hard drive / SSD replacement", desc: "Internal drive replacement or expansion card upgrade on Series consoles.", price: "Quote" },
      { title: "Power supply (case by case)", desc: "Internal PSU testing and replacement when the part is available.", price: "Quote" },
      { title: "HDMI port repair — not currently offered", desc: "Actively skilling up on HDMI reflow, but not accepting HDMI jobs right now. Happy to refer you to a specialist.", price: "—" },
    ],
    faqs: [
      { q: "Do you fix Xbox 360s?", a: "Yes — I'll work on 360s when parts are still available. Reach out with the model and issue first." },
      { q: "Do you repair Xbox HDMI ports?", a: "Not currently. HDMI reflow is a specialty and I'm training on it now, but I don't accept HDMI jobs at the moment. I'll refer you to a trusted specialist if that's what you need." },
      { q: "Can you fix the disc drive on a Series X?", a: "In most cases, yes — depending on whether it's the drive board or the mechanism. I diagnose and quote before any work." },
    ],
    keywords: ["xbox repair", "xbox series x repair", "xbox controller repair near me", "xbox cleaning susquehanna"],
  },

  "nintendo-switch": {
    slug: "nintendo-switch",
    device: "Nintendo Switch / OLED / Lite",
    short: "Switch",
    title: "Nintendo Switch Repair · Joy-Con Drift, Charge Port",
    metaDescription:
      "Nintendo Switch repair in Susquehanna PA. Joy-Con drift fixes, charge port replacement, screen and dock repair. Drop-off or mail-in across NEPA and Binghamton NY area.",
    h1: "Nintendo Switch Repair",
    intro:
      "All three Switch models — original, OLED, and Lite. The classics: Joy-Con drift, busted charge ports, cracked screens, and dying storage. Get it fixed without paying Nintendo's full replacement cost.",
    commonIssues: [
      { title: "Joy-Con drift fix", desc: "Replace the drifting analog stick module. Way cheaper than a new controller.", price: "$30" },
      { title: "General cleaning", desc: "Switches throttle and lag when dust clogs the cooling. Full clean and paste.", price: "$30" },
      { title: "Disc / game card slot repair", desc: "Cleaning and replacement when the card reader fails.", price: "Quote" },
      { title: "Hard drive / microSD swap", desc: "Internal storage and microSD reader replacement on Switch / Lite / OLED.", price: "Quote" },
      { title: "Power supply / charge port (case by case)", desc: "USB-C charge port replacement when the dock or charger no longer registers.", price: "Quote" },
      { title: "Dock HDMI repair — not currently offered", desc: "Actively training on HDMI reflow but not accepting HDMI dock jobs right now. Happy to refer you to a specialist.", price: "—" },
    ],
    faqs: [
      { q: "Can you fix Joy-Con drift?", a: "Yes — that's the most common Switch repair I do. Flat $30 per Joy-Con." },
      { q: "Do you fix Switch Lites?", a: "Yes, all three Switch models. Lite repairs sometimes take longer because of the integrated controllers." },
      { q: "Do you repair Switch dock HDMI ports?", a: "Not currently. HDMI reflow is a specialty and I'm actively training on it, but I don't accept those jobs yet. Reach out and I'll refer you to someone I trust." },
      { q: "What if my charge port stopped working?", a: "Bring it in or mail it. Charge port replacement is one of the most common Switch fixes." },
    ],
    keywords: ["nintendo switch repair", "joy-con drift fix", "switch charge port repair", "switch screen replacement"],
  },

  pc: {
    slug: "pc",
    device: "Desktop PC / Gaming PC",
    short: "PC",
    title: "PC Repair · Susquehanna, PA · In-Person Diagnostics & Upgrades",
    metaDescription:
      "Local PC repair in Susquehanna PA. GPU diagnostics, PSU replacement, full rebuilds, SSD upgrades, thermal paste. In-person only — drop off at 67 Grand St.",
    h1: "PC Repair · In-Person Service",
    intro:
      "Desktop and gaming PC repairs are in-person only — no shipping. Drop off at 67 Grand St in Susquehanna and I'll diagnose everything before quoting. From GPU swaps to full rebuilds.",
    commonIssues: [
      { title: "Won't boot / no display", desc: "Full diagnostic to isolate RAM, GPU, or PSU. You only pay for the fix you approve.", price: "Quote" },
      { title: "GPU / graphics card replacement", desc: "Install your card or source a replacement. I won't push parts you don't need.", price: "Labor + parts" },
      { title: "SSD / NVMe / RAM upgrade", desc: "HDD → SSD migration with full data transfer. RAM upgrades for newer games and multitasking.", price: "Quote" },
      { title: "PSU replacement", desc: "Bad or failing power supplies swapped for a quality replacement.", price: "Quote" },
      { title: "Thermal paste & cleaning", desc: "Full deep clean, repaste CPU/GPU. Brings older rigs back to life.", price: "Quote" },
      { title: "Custom build / full rebuild", desc: "Rebuild your PC from scratch with new components. Quote includes labor and parts at cost.", price: "Quote" },
    ],
    faqs: [
      { q: "Why is PC repair in-person only?", a: "PCs are too easy to damage in shipping, and most diagnostics need real-time testing with peripherals. Drop off in Susquehanna and we go from there." },
      { q: "Do you build custom gaming PCs?", a: "Yes. Tell me your budget and use case and I'll spec a build, then either build it for you or guide you through assembly." },
      { q: "Do you do motherboard repair?", a: "I don't do PCB-level / motherboard soldering work. If your motherboard is dead, I'll diagnose it and recommend a replacement." },
      { q: "How long does a PC repair take?", a: "Simple fixes: same day. Complex ones (waiting on parts, rebuild): a few days to a week." },
    ],
    keywords: ["pc repair Susquehanna PA", "gaming pc repair near me", "pc diagnostic", "ssd upgrade pc"],
  },

  laptop: {
    slug: "laptop",
    device: "Laptop",
    short: "Laptop",
    title: "Laptop Repair · SSD, RAM, Battery, Screen — Susquehanna PA",
    metaDescription:
      "Honest laptop repair in Susquehanna PA. SSD upgrades, RAM, battery replacement, screens, fans, hinges. All major brands. Serving Susquehanna, Hallstead, Lanesboro, Great Bend, and the Binghamton NY area.",
    h1: "Laptop Repair",
    intro:
      "Most laptops aren't worth replacing — most issues are fixable for under $150 in parts and labor. I work on all major brands. Quote depends on your make and model, but I'll diagnose for free before any work.",
    commonIssues: [
      { title: "Hard drive / SSD replacement", desc: "HDD to SSD swap with full Windows / data migration. Single biggest speed upgrade you can make.", price: "Quote" },
      { title: "Battery replacement", desc: "Quality battery installs on most major laptop brands.", price: "Quote" },
      { title: "Screen replacement", desc: "Cracked LCD, dead pixels, or backlight fix — when the part is available for your model.", price: "Quote" },
      { title: "Keyboard replacement", desc: "Full keyboard swap when the part is available. Common on most Dell, HP, Lenovo, ASUS laptops.", price: "Quote" },
      { title: "Disc drive replacement", desc: "Swap a dead optical drive or convert the bay to a second SSD caddy.", price: "Quote" },
    ],
    faqs: [
      { q: "What brands of laptops do you work on?", a: "All major brands — Dell, HP, Lenovo, ASUS, Acer, MSI, Razer. Parts availability varies by model; I'll confirm before quoting." },
      { q: "Do you replace laptop batteries?", a: "Yes — I source a quality battery and swap it. Most batteries fall in a similar price range." },
      { q: "Do you do motherboard repair?", a: "No — I don't do PCB-level soldering or motherboard rework on laptops. If the board itself is dead I'll tell you honestly so you can make a call." },
      { q: "Can you upgrade my old laptop?", a: "Yes. SSD + RAM upgrades make 5–8 year old laptops feel new. I'll tell you honestly if it's not worth the money." },
    ],
    keywords: ["laptop repair Susquehanna PA", "laptop ssd upgrade", "laptop screen repair near me", "laptop battery replacement"],
  },
};

export const SERVICE_PAGE_LIST = Object.values(SERVICE_PAGES);
